import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { GroupLayerHotkeyType } from '../../type';

export const groupUnpackItem = ({ activeLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);

    if (!activeLayer) return null;

    const disabled = !framework.service.flatLayer.checkIsFormalGroup(activeLayer);
    const notBrokenGroup = !framework.service.flatLayer.checkBrokenGroup(activeLayer);
    const isArranging = framework.service.agentLayout.checkArranging(activeLayer);

    const type = GroupLayerHotkeyType.UNPACK;
    const item = {
        disabled: disabled || notBrokenGroup || isArranging,
        name: $t((v) => v.contextMenuLayer.menuConfig.brokeGroup),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            framework.service.hotkey.__emit(type, { from: 'content-menu' });
        },
    };

    return item;
};
